import { paginationDuckCreator } from 'axl-ducks';
import { pageNames } from '@atc/bonnet-paths';

export default paginationDuckCreator({
    namespace: pageNames.DEALER_DETAILS,
    storePrefix: `${pageNames.DEALER_DETAILS}.`,
});
